import { getCompanyByName } from "../../../http";

export const findCompanyByName = async (payload:any) => {
    
  try {
    const { data } = await getCompanyByName(payload);
    return data;
  } catch (error:any) {
    throw error;
  }
};
